(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mzube-gift-chooser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mz-gift-chooser')) {
  customElements.define('mz-gift-chooser', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const form = this.querySelector('form');
      const interest = this.querySelector('[data-gift-interest]');
      const budget = this.querySelector('[data-gift-budget]');
      if (!form || !interest || !budget) return;
      this.dataset.ready = 'true';
      form.hidden = false;
      this.querySelector('.mz-chooser__fallback').hidden = true;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const destination = new URL(interest.value, window.location.origin);
        if (destination.origin !== window.location.origin) return;
        if (budget.value) destination.searchParams.set('filter.v.price.lte', budget.value);
        window.location.assign(destination.href);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
